import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import {Overlay, OverlayHeading, OverlaySection} from "../../components/overlay.js";
import {Button} from "../../components/form.js";
import {isModalClosed, getModalTitle, getModalMessage, getModalButtonLabel} from "../store.js";
import {closeModal} from "../actions.js";

import "./modal.scss";

export default function Modal() {

  const dispatch = useDispatch();
  
  const isClosed = useSelector(isModalClosed);
  const title = useSelector(getModalTitle);
  const message = useSelector(getModalMessage);
  const buttonLabel = useSelector(getModalButtonLabel);

  const onCloseHandler = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  return (
    <Overlay className="modal" modal open={!isClosed} onClose={onCloseHandler}>
      <OverlayHeading>{title}</OverlayHeading>
      <OverlaySection>
        <div className="modal__message">{message}</div>
        <Button className="modal__button" primary continue onClick={onCloseHandler}>{buttonLabel}</Button>
      </OverlaySection>
    </Overlay>
  );
}